
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"40","cy":"40","r":"40","fill":"#BA667C"}}),_c('path',{attrs:{"d":"M52 28L28 52M28 28l24 24","stroke":"#fff","stroke-width":"8","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    